// extracted by mini-css-extract-plugin
export default {"header":"Header_header__fOEiW","headerText":"Header_headerText__si55D","breadcrumb":"Header_breadcrumb__fJjT+","links":"Header_links__nAui6"};